import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab"
import { Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"
import { Stack } from "@mui/system"

import { useDateTime } from "../../localization/useDateTime"
import { RoadmapImplementationType, RoadmapItem } from "../newsTypes"

const useStyles = makeStyles<{ isActive: boolean }>()((theme, { isActive }) => ({
    timelineItem: {
        cursor: "pointer",
    },
    timelineContent: {
        padding: "1rem",
        marginLeft: "1rem",
        backgroundColor: isActive ? "#EEEEEE" : "transparent",
        borderBottom: !isActive ? `1px solid ${theme.palette.divider}` : "none",
    },
    date: {
        color: theme.palette.text.secondary,
        fontSize: "0.75rem",
    },
    title: {
        fontSize: "0.875rem",
        fontWeight: 500,
        color: theme.palette.text.primary,
        lineHeight: 1.4,
    },
    dot: {
        margin: "0 .5rem",
        color: "#94A3B8",
    },
    type: {
        fontSize: "0.75rem",
        fontWeight: 700,
        lineHeight: 1.6,
        color: theme.palette.tailwind.green[800],
        textTransform: "capitalize",
    },
}))

interface RoadmapTimelineItemProps {
    item: RoadmapItem
    isLast?: boolean
    isActive: boolean
    isUser?: boolean
    onClick?: () => void
}

export function RoadmapTimelineItem({ item, isLast, isUser, isActive, onClick }: RoadmapTimelineItemProps) {
    const { classes } = useStyles({ isActive })
    const dateTimeFactory = useDateTime()

    const formattedDate = dateTimeFactory.formatDate(dateTimeFactory.fromApi(item.publishDate))
    const { implementationType } = item.roadmapDetails
    const hideType = !implementationType || (implementationType === RoadmapImplementationType.FEATURE && isUser)

    return (
        <TimelineItem className={classes.timelineItem} onClick={onClick}>
            <TimelineSeparator>
                <TimelineDot
                    sx={{
                        margin: 0,
                    }}
                    variant={isActive ? "filled" : "outlined"}
                />
                {!isLast && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent className={classes.timelineContent}>
                <Stack direction="row" alignItems="center" mb={0.5}>
                    <Typography className={classes.date}>{formattedDate}</Typography>
                    {hideType ? null : (
                        <>
                            <FontAwesomeIcon className={classes.dot} width=".25rem" icon={faCircle} />
                            <Typography className={classes.type}>
                                {implementationType.toLowerCase()}
                            </Typography>
                        </>
                    )}
                </Stack>
                <Typography className={classes.title}>{item.subject}</Typography>
            </TimelineContent>
        </TimelineItem>
    )
}
